import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';
import { NzSkeletonComponent } from "ng-zorro-antd/skeleton";

@Component({
  selector: 'app-custom-loading-overlay',
  standalone: true,
  imports: [SkeletonLoaderComponent, NzSkeletonComponent],
  template: `
    <div class="ag-overlay-loading-center">
      <app-skeleton-loader></app-skeleton-loader>
    </div>
  `,
  styles: [`
    app-skeleton-loader{
      height: 100%;
      width: 100%;
    }

    .ag-overlay-loading-center {
      display: flex;
      align-items: center;
      width: 100vw;
      height: 100vh;
      justify-content: center;
    }
  `]
})
export class CustomLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  public params!: ILoadingOverlayParams & { loadingMessage: string };

  agInit(params: ILoadingOverlayParams & { loadingMessage: string }): void {
    this.params = params;
  }
}
